import CorporatePage from './corporatePage.component';

export default CorporatePage;